<button
    (click)="toggleRadiusSelection()"
    class="radius-toggle-btn"
    [ngClass]="isCircleSelectionActive ? 'selection-active' : ''"
    matTooltip="Analyze custom area"
>
    <app-icon
        svgIcon="radiusButton"
    >
    </app-icon>
</button>

<div *ngIf="isCircleSelectionActive" class="circle-slider-container">
    <h4>Analysis Area</h4>
    <mat-slider
        class="cirlce-radius-slider"
        max="50"
        min="0.5"
        step="0.5"
        [disabled]="!selectionService.circleSelectionStatus"
        [matTooltip]="!selectionService.circleSelectionStatus ? 'Pick a new location to adjust the radius' : ''"
        [matTooltipPosition]="'above'"
        style="width: 100%"
  >
      <input (valueChange)="changeSelectionRadius($event)"
             #circleSlider
             matSliderThumb
             [(ngModel)]="circleRadius"
      >
    </mat-slider>
  <p>{{ circleRadius }} mi radius</p>

  <div class="button-wrapper" *ngIf="(combinedCellService.cellCreationStatus | async) as status">
    <button (click)="handleRequestCombinedCell()"
            [ngClass]="status === 'in-progress' ? 'loading' : (status === 'error' ? 'error' : '')"
            class="gradient-button"
            [matTooltip]="status === 'in-progress' ? 'Loading may take some time' : ''"
            [matTooltipPosition]="'right'"
            [disabled]="!selectionService.isCircleRendered"
    >{{ status === 'error' ? 'Error, try again' :
      (status === 'in-progress' ? 'Please wait' : 'Analyze this area')
      }}</button>

    <button *ngIf="selectionService.isCircleRendered"
            (click)="handleSelectNewLocation()"
            class="white-button-gradient reset-cell-button"
    >Pick new location</button>
  </div>


    <button app-icon-button [iconSize]="'12px'" (click)="closeSelection()" class="slider-close-button">
        <app-icon svgIcon="cancel"></app-icon>
    </button>
</div>
